import React from 'react';

// eslint-disable-next-line react/prop-types
export const DivLink = ({ componentName, aLabel, onClick, children }) => {
  return (<div className={`${componentName}__menu-row`} role="button" tabIndex="0"
               aria-label={`${aLabel}`}
               onClick={onClick}>
    {children}
  </div>);
};
